import { useCallback, useEffect } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { currLayerSelector, layersSelector, popLayer, pushLayer } from "@/domains/layer/slice";

export default (layer: string) => {
  const dispatch = useAppDispatch();
  const layers = useAppSelector(layersSelector);
  const currLayer = useAppSelector(currLayerSelector);

  useEffect(() => {
    dispatch(pushLayer(layer));

    return () => {
      dispatch(popLayer());
    };
  }, [dispatch, layer]);

  const pushLayerHandler = useCallback(
    (value: string) => {
      dispatch(pushLayer(value));
    },
    [dispatch],
  );

  const popLayerHandler = useCallback(() => {
    dispatch(popLayer());
  }, [dispatch]);

  return {
    pushLayerHandler,
    popLayerHandler,
    layers,
    currLayer,
  };
};
